/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import GraphConfiguration from 'embercom/objects/series/node/graph-configuration';
import StandardNodeComponentConfiguration from 'embercom/objects/series/node/standard-node-component-configuration';
import ConnectorConfiguration from 'embercom/objects/series/node/connector-configuration';
import StatsConfiguration from 'embercom/objects/series/node/stats-configuration';
import {
  objectTypes,
  seriesEdgeTypes,
} from 'embercom/models/data/matching-system/matching-constants';
import renderPreview from '@intercom/embercom-composer/lib/render-preview';
import { htmlToTextContent } from 'embercom/lib/html-unescape';

export default class EmailGraphConfiguration extends GraphConfiguration {
  objectType = objectTypes['email'];

  constructor(seriesNode) {
    super(...arguments);
    this.componentConfig = new StandardNodeComponentConfiguration({
      icon: 'series/content/email',
      objectType: this.objectType,
      statsSummaryConfigurationComponent: new StatsConfiguration({
        verb: 'sent',
        component: 'series/node/standard-stats-summary',
      }),
    });
  }

  get connectors() {
    let primaryLabel = 'WHEN SENT';
    let alternativeLabel = 'IF NOT ELIGIBLE TO RECEIVE EMAIL';
    let connectors = [
      new ConnectorConfiguration({
        label: primaryLabel,
        edgeType: seriesEdgeTypes.primary,
        component: 'series/node/connectors/content-shortcuts-connector',
      }),
    ];
    if (this.node.appService.app.canUseSeriesEmailUnsubscribeLinks) {
      connectors.push(
        new ConnectorConfiguration({
          label: alternativeLabel,
          edgeType: seriesEdgeTypes.alternative,
          component: 'series/node/connectors/standard-connector',
        }),
      );
    }
    return connectors;
  }

  get inferredTitle() {
    let contentPreview = this.node.contentPreviews.firstObject?.contentPreviewData?.content;
    if (contentPreview) {
      let previewHtml = renderPreview(contentPreview, {});
      return htmlToTextContent(previewHtml);
    }
    return '';
  }

  get primaryPredecessorLabel() {
    return `Received '${this.title}'`;
  }

  get checkpointStats() {
    return [
      { label: 'successfully sent', value: this.node.completedCheckpointCount },
      {
        label: 'ineligible to send',
        value:
          this.node.completedTraversedAlternativeEdgesCheckpointCount +
          this.node.completedEjectedCheckpointCount,
      },
    ];
  }
}
